// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".signar-logo[data-v-11d8595a] {\n  width: 100px;\n  margin: 0 auto 15px;\n}", ""]);
// Exports
module.exports = exports;
